if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.bindOnScroll = this.onScroll.bind(this);
      this.debounceResize = debounce(this.setGalleryOffset.bind(this), 200)
    }

    connectedCallback() {
      this.setVariables();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.bindOnScroll);
      window.removeEventListener('resize', this.debounceResize);
    }

    setVariables() {
      this.medias = Array.from(this.querySelectorAll('.slider__item.media-gallery__item'));
      this.filteredMedias = this.medias.filter(media => media.getBoundingClientRect().width > 0);
      this.variantMedias = this.medias.filter(media => media.classList.contains('.media-gallery__item--variant'))
      this.slider = this.querySelector('component-slider');
      this.scrollThumbnailsContainer = this.querySelector('.media-gallery__thumbnails');
      this.header = document.querySelector('.header-wrapper');
      this.counterType = this.dataset.counterType;

      this.setSrollThumbnails();
      this.setGalleryOffset();

      window.addEventListener('scroll', this.bindOnScroll);
      window.addEventListener('resize', this.debounceResize);
    }

    setActiveMedia(id, prepend) {
      const media = this.medias.find(element => element.dataset.mediaId == id);
      if (!media || media.classList.contains('is-active')) return;

      this.medias.forEach(media => {
        media.classList.remove('is-active');
      });
      media.classList.add('is-active');

      const container = this.querySelector('.slider__list');
      if (prepend == true && container) {
        container.insertBefore(media, this.medias[0]);
        requestAnimationFrame(() => {
          this.resetSlider();
          this.setVariables();
        })
      }
    }

    resetSlider() {
      if (!this.slider) return;
      this.slider.removeEventListeners();
      this.slider.setUpSlider();
    }

    setSrollThumbnails() {
      if (!this.scrollThumbnailsContainer) return;

      this.scrollThumbnailsContainer.innerHTML = '';
      const fragment = document.createDocumentFragment();
      this.filteredMedias.forEach((media, index) => {
        const item = document.createElement('div');
        item.classList.add('thumbnail', `thumbnail--${this.counterType.slice(0, -1)}`);
        item.dataset.id = media.dataset.id;
        if (this.counterType === 'numbers') item.textContent = index + 1;
        if (this.counterType === 'images') item.style.setProperty('--thumbnail-image', `url(${media.dataset.sliderThumbnailImage})`)
        if (index === 0) item.classList.add('active');
        item.addEventListener('click', () => this.scrollIntoMedia(media, item));
        fragment.appendChild(item);
      });
      this.scrollThumbnailsContainer.appendChild(fragment);

      this.thumbnails = Array.from(this.scrollThumbnailsContainer.querySelectorAll('.thumbnail'))
    }

    scrollIntoMedia(media, thumbnail) {
      window.scrollTo({ top: media.offsetTop, behavior: 'smooth' });
      this.setThumbnailActive(thumbnail)
    }

    onScroll() {
      if (!this.thumbnails || this.thumbnails.length <= 0) return;
      this.thumbnails.forEach(t => {
        t.classList.remove('active');
      })
      this.filteredMedias.forEach((media) => {
        if (window.scrollY >= media.offsetTop && window.scrollY <= media.offsetTop + media.getBoundingClientRect().height) {
          this.setThumbnailActive(this.thumbnails.find(thumbnail => thumbnail.dataset.id == media.dataset.id));
        }
      })
    }

    setThumbnailActive(thumbnail) {
      if (!thumbnail) return;

      thumbnail.classList.add('active');

      const containerScrollTop = this.scrollThumbnailsContainer.scrollTop;
      const containerClientHeight = this.scrollThumbnailsContainer.clientHeight;
      const thumbnailOffsetTop = thumbnail.offsetTop;
      const thumbnailHeight = thumbnail.getBoundingClientRect().height;
      const containerGap = parseFloat(computePixelValue(getComputedStyle(this.scrollThumbnailsContainer).rowGap) || computePixelValue(getComputedStyle(this.scrollThumbnailsContainer).gap) || 0);
      const scrollOffsetY = thumbnailHeight + containerGap;
      let newScrollTop = containerScrollTop;

      // Ensure thumbnail is fully visible vertically
      if (thumbnailOffsetTop < containerScrollTop + scrollOffsetY) {
        newScrollTop = thumbnailOffsetTop - scrollOffsetY;
      } else if (thumbnailOffsetTop + thumbnailHeight > containerScrollTop + containerClientHeight - scrollOffsetY) {
        newScrollTop = thumbnailOffsetTop + thumbnailHeight - containerClientHeight + scrollOffsetY;
      }

      this.scrollThumbnailsContainer.scrollTo({ top: newScrollTop, behavior: 'smooth' });
    }

    setGalleryOffset() {
      this.style.setProperty('--gallery-offset-top', `${this.offsetTop}px`);
      this.style.setProperty('--gallery-offset-left', `${this.offsetLeft}px`);
    }
  }

  customElements.define('media-gallery', MediaGallery);
}